import React from "react";
import { useTranslation } from "react-i18next";
import { Theme } from "./Theme";
import { WebsiteBuilderToolbarMenuSections } from "../../../WebsiteBuilderToolbarMenuSections";
import { IWebsiteBuilderTheme } from "redux/reducers/models/websiteBuilder";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import { websiteBuilderSelectTheme } from "redux/actions/websiteBuilder/websiteBuilder";

export function ThemesView() {
  const theme = useAppSelector(store => store.websiteBuilderStore.theme);
  const availableThemes = useAppSelector(store => store.websiteBuilderStore.availableThemes);
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  function renderCurrentThemeSection() {
    return <Theme theme={theme} selected={true} />;
  }

  function selectTheme(theme: IWebsiteBuilderTheme) {
    dispatch(websiteBuilderSelectTheme({ id: theme?.id }));
  }

  function renderFeaturedThemesSection() {
    return (
      <>
        {availableThemes?.map(availableTheme => (
          <Theme
            key={availableTheme?.id}
            theme={availableTheme}
            selected={false}
            selectTheme={() => selectTheme(availableTheme)}
          />
        ))}
      </>
    );
  }

  return (
    <WebsiteBuilderToolbarMenuSections
      sections={[
        {
          title: t("Current Theme"),
          content: renderCurrentThemeSection(),
        },
        {
          title: t("Featured Themes"),
          content: renderFeaturedThemesSection(),
        },
      ]}
    />
  );
}
